import { usePromisedRequest } from "../Common/request";
import { resolveWithBody } from "./Utils/utils";

export type SetupChecklistItemKey = "name" | "dates" | "location" | "contactInfo" | "categories" | "images";

export type UrgencyLevel = "none" | "warning" | "urgent";

export type SetupChecklistItem = {
    itemKey: SetupChecklistItemKey;
    done: boolean;
};

export type SetupChecklistPublication = "draft" | "privateLive" | "public";

export type CapStatus = {
    type: "warning" | "blocked";
    count: number;
    limit: number;
};

export type SetupChecklistResponse = {
    items: SetupChecklistItem[];
    nextItemKey: SetupChecklistItemKey | null;
    urgencyLevel: UrgencyLevel;
    publication: SetupChecklistPublication;
    underReview: boolean;
    urlSlug: string | null;
    capStatus: CapStatus | null;
    visible: boolean;
    canMakePublic: boolean;
};

export const setupChecklistApi = {
    getSetupChecklist(eventId: number): Promise<SetupChecklistResponse> {
        return usePromisedRequest<SetupChecklistResponse>({
            url: `/api/admin/events/${eventId}/setup-checklist`,
            method: "get",
            json: true,
        }).then(resolveWithBody());
    },
};
